import actions from "./actions.js";
import mutations from "./mutations.js";
import state from "./state.js";
import persist from "./persist.js";

import StateMachine from "@rankers/lib/state_machine";

export default new StateMachine({
  name: "DealsWidget",
  actions,
  mutations,
  state,
  persist,
  persistentStorageKey: "DEALS_WIDGET__STORE",
  persistentStore: window.localStorage,
});
